(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicePaymentDeleteController',InvoicePaymentDeleteController);

    InvoicePaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'InvoicePayment'];

    function InvoicePaymentDeleteController($uibModalInstance, entity, InvoicePayment) {
        var vm = this;

        vm.invoicePayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InvoicePayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
